export { default as CGMTab } from './CGMTab';
export { default as BGMTab } from './BGMTab';
